// Configuración para el servicio de analytics
export const ANALYTICS_CONFIG = {
    // URL del formulario de Google
    FORM_URL: 'https://docs.google.com/forms/d/e/1FAIpQLSd-2tUdC_YqcpjNh6J1LS-w3amu_GTjcFvXANn4u0j-7PYSgw/formResponse',
    
    // Campos del formulario
    FIELDS: {
        FECHA: 'entry.1539795438',      // fecha
        HORA: 'entry.2108407528',       // hora  
        URL: 'entry.419684631',         // url
        USER: 'entry.1193066290',       // user
    },
    
    // Configuración de zona horaria
    TIMEZONE: 'es-CO',
    
    // Configuración de logging
    LOGGING: {
        ENABLED: process.env.NODE_ENV === 'development',
        LEVEL: 'info' // 'info', 'warn', 'error'
    },
    
    // Configuración de tracking
    TRACKING: {
        SESSION_BASED: true,        // Solo una visita por sesión
        ROUTE_CHANGES: true,        // Trackear cambios de ruta
        USER_AGENT: true,           // Incluir user agent
        FALLBACK_ENABLED: true      // Habilitar método fallback
    }
};

export default ANALYTICS_CONFIG;
